module.exports = __webpack_public_path__ + "static/media/pobble-home-discuss-the-image.7a91d9c2.png";